import React, { useRef, useState, useEffect, useMemo } from "react";

import "../Styles/ProfileLoginPage.css";

import { useNavigate } from "react-router-dom";

import Select from "react-select";

import { validate_profile_activation } from "../api/serverWrapper";

import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";

import { saveData } from "../utils/store-data";

import { useMasterData } from "../context/MasterDataContext";

import { selectStyles } from "../utils/commonFunctions";

export default function ProfileLoginPage() {
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const { allCountyMasterData } = useMasterData();

  const selectRef = useRef(null);

  const inputRefs = useRef([]);

  const [phone, setPhone] = useState("");

  const [countryCode, setCountryCode] = useState("91");

  const [showSelect, setShowSelect] = useState(false);

  const [btnLoading, setBtnLoading] = useState(false);

  const [codeDigits, setCodeDigits] = useState(Array(6).fill(""));

  /* COUNTRIES */

  const countries = useMemo(() => {
    if (!allCountyMasterData || allCountyMasterData.length === 0) {
      return [];
    }

    return allCountyMasterData.map((c) => {
      const code = c.phonecode?.startsWith("+")
        ? c.phonecode
        : `+${c.phonecode}`;

      return {
        value: code.replace("+", ""),
        label: `${c.name} (${code})`,
        name: c.name,
      };
    });
  }, [allCountyMasterData]);

  /* CLOSE SELECT */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowSelect(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* CODE INPUT */

  const handleInputChange = (e, index) => {
    setErrorMessage("");

    const value = e.target.value.toUpperCase();

    const char = value.slice(0, 1);

    const newDigits = [...codeDigits];

    newDigits[index] = char;

    setCodeDigits(newDigits);

    if (char && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData
      .getData("text")
      .trim()
      .toUpperCase()
      .slice(0, 6);

    if (!pasteData) return;

    const chars = pasteData.split("");

    const newDigits = Array(6).fill("");

    chars.forEach((char, index) => {
      if (index < 6) {
        newDigits[index] = char;
      }
    });

    setCodeDigits(newDigits);

    const nextIndex = chars.length >= 6 ? 5 : chars.length;

    inputRefs.current[nextIndex]?.focus();
  };

  const showToast = (message) => {
    setErrorMessage(message);

    setTimeout(() => {
      setErrorMessage("");
    }, 2000); // 2 seconds
  };

  /* API */

  const validateProfile = async () => {
    if (btnLoading) return;

    const clientCode = codeDigits.join("");

    if (!phone && clientCode.length !== 6) {
      showToast("Please enter phone number and activation code");
      return;
    }

    if (!phone) {
      showToast("Please enter phone number");
      return;
    }

    if (phone.length < 10) {
      showToast("Please enter valid phone number");
      return;
    }

    if (clientCode.length !== 6) {
      showToast("Please enter activation code");
      return;
    }
    try {
      setBtnLoading(true);
      console.log(phone, clientCode);

      const resp = await validate_profile_activation(clientCode, phone);

      if (resp.data && resp.data.length > 0) {
        await saveData(USER_ID, resp.data[0].User.UserId);

        await saveData(AGENT_LOGIN, false);

        await saveData(CLIENT_LOGIN, false);

        await saveData(PROFILE_LOGIN, true);

        await saveData(CLIENT_PROFILE_CODE, clientCode);

        navigate("/profileforclient", {
          state: {
            client: resp.data[0],
          },
        });
      }else if(resp.code === 500){
         showToast(`${resp.message}`);
      }
       else {
        showToast("Invalid phone number or activation code");
      }
    } catch (err) {
      console.error(err);

      alert("Error validating profile");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="profile-login-container">
      {/* HEADER */}

      <header className="profile-login-header">
        <img
          src={require("../assests/images/agent-login-signup-top-logo.png")}
          alt="logo"
          className="header-logo"
        />

        <div className="signup-link">Sign up</div>
      </header>

      {/* CARD */}

      <div className="profile-login-card">
        <h2 className="welcome-title">Activate your Profile</h2>

        <div className="title-line"></div>

        {/* PHONE */}

        <div className="form-center-wrapper">
          {/* PHONE */}

          <div className="phone-input-onboarding">
            <label className="phone-label">Phone no given to your Agent</label>
            {errorMessage && (
              <div className="profile-error-toast">{errorMessage}</div>
            )}

            <div className="phone-input-box" ref={selectRef}>
              <div className="country-code-wrapper">
                <span
                  className="country-code"
                  onClick={() => setShowSelect((prev) => !prev)}
                >
                  +{countryCode}
                </span>

                {showSelect && (
                  <div className="country-select-popup">
                    <Select
                      classNamePrefix="react-select"
                      options={countries}
                      styles={selectStyles}
                      value={countries.find((c) => c.value === countryCode)}
                      onChange={(opt) => {
                        setCountryCode(opt.value);
                        setShowSelect(false);
                      }}
                      autoFocus
                      isSearchable
                    />
                  </div>
                )}
              </div>

              <input
                type="tel"
                placeholder="Contact Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                onPaste={(e) => {
                  e.preventDefault();

                  const pastedData = e.clipboardData
                    .getData("text")
                    .replace(/\D/g, "")
                    .slice(0, 10);
                  setErrorMessage("");
                  setPhone(pastedData);
                }}
                maxLength={10}
                className="phone-input-field"
              />
            </div>
          </div>

          {/* CODE */}

          <label className="activation-label">
            Profile Activation code (Ask your Agent)
          </label>

          <div className="code-inputs">
            {codeDigits.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                className="code-box"
                ref={(el) => (inputRefs.current[index] = el)}
                value={digit}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
              />
            ))}
          </div>
        </div>

        {/* BUTTON */}

        <button className="join-button" onClick={validateProfile}>
          {btnLoading ? "Loading..." : "Join ❯"}
        </button>
      </div>
    </div>
  );
}
